// Contacts directory search. It runs over the fields the server actually sent
// for this viewer, so it can never match on information a Basic viewer is not
// permitted to receive (no email/phone in the payload means nothing to match).
// It never deduplicates: People who share an email each match and each appear.

import type { DirectoryPerson } from '../types';
import { displayedPositionNames } from './directoryPositions.ts';

const digits = (v: string) => v.replace(/\D/g, '');

export function searchDirectory(
  people: DirectoryPerson[],
  query: string,
  districtName: (id: string) => string,
): DirectoryPerson[] {
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return people;
  return people.filter((p) => {
    const haystack = [
      p.name,
      p.ref ?? '',
      displayedPositionNames(p).join(' '),
      (p.committees ?? []).join(' '),
      p.districtIds.map(districtName).join(' '),
      p.email ?? '',
      p.secondaryEmail ?? '',
      p.phone ?? '',
    ].join(' ').toLowerCase();
    const phoneDigits = digits(p.phone ?? '');
    return tokens.every((t) => {
      if (haystack.includes(t)) return true;
      const d = digits(t);
      return d.length >= 3 && d === t.replace(/[^\d]/g, '') && phoneDigits.includes(d);
    });
  });
}
